import { LOGO_URL } from "@/lib/constants";

export default function Logo({ className = "h-9 w-9", showWordmark = true, dark = false }) {
  return (
    <a
      href="/"
      data-testid="brand-logo"
      className="flex items-center gap-2.5 group"
    >
      <span
        className={`relative ${className} rounded-lg overflow-hidden grid place-items-center bg-black ring-1 ring-black/5 group-hover:ring-emerald-400/40 transition-all`}
      >
        <img
          src={LOGO_URL}
          alt="Website Walsh"
          className="w-full h-full object-cover"
        />
      </span>
      {showWordmark && (
        <span
          className={`font-display font-bold text-[1.05rem] leading-none tracking-tight transition-colors ${
            dark ? "text-white" : "text-[color:var(--ww-charcoal)]"
          }`}
        >
          Website <span className="text-brand-gradient">Walsh</span>
        </span>
      )}
    </a>
  );
}
